import React, {useEffect, useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Collapse} from 'reactstrap';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory from 'react-bootstrap-table2-paginator';
import { confirmAlert } from 'react-confirm-alert';

// components
import TranslateButton from "../../../components/buttons/TranslateButton";
import XailingRoutFilters from "./_filters";
import { ActiveFormatter } from "../../../components/tables/activeFormater";
import {ButtonTableFilter, GenericTableButton,} from "../../../components/buttons/buttonsActions";
import { showToastCustom } from "../../../components/toast/customToast";
import { showLoader } from "../../../components/loader/loader";
import {XailingRoutProductModal} from "../xailingRoutProduct/XailingRoutProductModal";

// label
import {
	ARE_YOU_SHURE_MSG, ARE_YOU_SHURE_TITLE, error, LB_ACTIONS, LB_ACTIVE, LB_CODE, LB_ORDER, LIST,
	NO, NO_DATA_FOUND, XA_DESTINY_PORT, XA_ORIGIN_PORT, YES
} from "../../../components/i18n/i18n";
import {TT_DELETE, TT_EDIT, TT_PRODUCTS, TT_SCHEDULE} from "../../../components/i18n/toolTips";

// services
import { xailingRoutService } from "../../../jwt/_services/xailing/xailingRoutService";

export default function XailingRoutList(props) {
	const [fbDataBaseId] = useState(props?.app?.fbDataBase?.id);
	const [sizePerPage, setSizePerPage] = useState(10);
	const [page, setPage] = useState(1);
	const [currentIndex, setCurrentIndex] = useState(0);
	const [totalSize, setTotalSize] = useState(10);
	const [listItems, setListItems] = useState([]);
	const [loading, setLoading] = useState(false);

	const [xailingRout, setXailingRout] = useState(null);
	const [showModal, setShowModal] = useState(true);
	const modalRef = useRef(null);

	// Filter props
	const [collapsed, setCollapsed] = useState(false);
	const [dataFilter, setDataFilter] = useState({
		code  : null,
		status  : null,
		harborFrom  : null,
		harborTo  : null,
	});

	useEffect(() => refreshDataList(page, currentIndex, sizePerPage, dataFilter), []);

	const refreshDataList = (page, currentIndex, sizePerPage, _dataFilters) => {
		setLoading(true);
		xailingRoutService.search(currentIndex, sizePerPage, _dataFilters)
			.then(result => {
				if (result){
					setListItems(result.data);
					setTotalSize(result.total);
					setCurrentIndex(currentIndex);
					setPage(page);
					setSizePerPage(sizePerPage);
				} else {
					setListItems([]);
					setTotalSize(0);
					setCurrentIndex(0);
					setPage(1);
					setSizePerPage(10);
				}
				setLoading(false);
			})
			.catch(errorMessage => {
				setLoading(false);
				setListItems([]);
				setTotalSize(0);
				setCurrentIndex(0);
				setPage(1);
				setSizePerPage(10);
				showToastCustom(error, errorMessage);
			});
	}

	const handleTableChange = (type, {page, sizePerPage}) => {
		let index = (page - 1) * sizePerPage
		refreshDataList(page, index, sizePerPage, dataFilter);
	};

	const confirmDelete = (data) => {
		return confirmAlert({
			closeOnEscape: true,
			closeOnClickOutside: true,
			customUI: ({onClose}) => {
				return (
					<div className='custom-ui'>
						<h1>{ARE_YOU_SHURE_TITLE}</h1>
						<p>{ARE_YOU_SHURE_MSG}</p>
						<button onClick={onClose}>{NO}</button>
						<button className={"btn-alert-delete"} onClick={() => {
							deleteItem(data)
							onClose();
						}}>
							{YES}
						</button>
					</div>
				);
			}
		});
	};

	const deleteItem = (data) => {
		setLoading(true);

		xailingRoutService.deleteItem(data.id, fbDataBaseId)
			.then(_ => refreshDataList(page, currentIndex, sizePerPage, dataFilter))
			.finally(() => setLoading(false));
	}

	const editItem = (data) => {
		const itemToEdit = listItems.find(n => n.id === data.id);
		props.setForm(true, itemToEdit, "FORM");
	}

	const editSchedule = (data) => {
		const itemToEdit = listItems.find(n => n.id === data.id);
		props.setForm(true, itemToEdit, "SCHEDULE");
	}

	const refreshFiltered = (_dataFilter) => {
		setDataFilter(_dataFilter);
		refreshDataList(page, currentIndex, sizePerPage, _dataFilter);
	}

	const showFilters = () => setCollapsed(!collapsed);

	const activeFormatter = (cell) => <ActiveFormatter active={cell}/>

	const editComponents = (data) => {
		setXailingRout(data);
		setShowModal(true);
		modalRef.current.showModal(data);
	}

	const actionsFormatter = (cell, row) => <>
		<GenericTableButton toolTip={TT_DELETE} icon={'fa-trash'} permission={'delete'} onClick={() => confirmDelete(row)}/>
		<GenericTableButton toolTip={TT_EDIT} icon={'fa-pen'} permission={'edit'} onClick={() => editItem(row)}/>
		<GenericTableButton toolTip={TT_SCHEDULE} icon={'fa-clock'} permission={'edit'} onClick={() => editSchedule(row)}/>
		<TranslateButton item={row} service={xailingRoutService} />
		<GenericTableButton toolTip={TT_PRODUCTS} icon={'fa-box-open'} permission={'edit'} onClick={() => editComponents(row)}/>
	</>

	const columns = [
		{
			dataField: 'id',
			headerStyle: {width: '0px'},
			text: 'ID',
			hidden: true
		}, {
			dataField: 'code',
			text: `${LB_CODE}`,
		},  {
			dataField: 'fromHarborTitle',
			text: `${XA_ORIGIN_PORT}`,
		}, {
			dataField: 'toHarborTitle',
			text: `${XA_DESTINY_PORT}`,
		}, {
			dataField: 'status',
			text: `${LB_ACTIVE}`,
			headerAlign: 'center',
			align: 'center',
			headerStyle: {width: '50px'},
			formatter: activeFormatter
		}, {
			dataField: 'showOrder',
			text: `${LB_ORDER}`,
			headerAlign: 'center',
			align: 'center',
			headerStyle: {width: '50px'},
		}, {
			dataField: 'action',
			text: `${LB_ACTIONS}`,
			isDummyField: true,
			headerAlign: 'center',
			align: 'center',
			headerStyle: {width: '290px'},
			formatter: actionsFormatter
		}
	];

	return (
		<>
			{loading && showLoader()}
			<Card>
				<CardTitle className="bg-light border-bottom p-3 mb-0">
					<i className="far fa-list-alt mr-2"> </i>
					{LIST}
					<div className="float-right">
						<ButtonTableFilter onClick={() => showFilters()} collapsed={collapsed}/>
					</div>
				</CardTitle>
				<Collapse isOpen={collapsed}  >
					<XailingRoutFilters refreshFiltered={refreshFiltered} />
				</Collapse>
				<CardBody className="">
					<BootstrapTable
						striped hover
						tableHeaderClass='mb-0'
						remote
						keyField="id"
						data={listItems}
						columns={columns}
						noDataIndication={NO_DATA_FOUND}
						pagination={paginationFactory({page, sizePerPage, totalSize})}
						onTableChange={handleTableChange}
					/>
				</CardBody>
			</Card>
			{
				showModal &&
				<XailingRoutProductModal
					ref={modalRef}
					item={xailingRout}
					app={props.app}
				/>
			}
		</>
	)
}